
const digest = '19f1d5a8bf0af900a8bbc7d3b96c11799bce176e5323ef0d786c37c072b9a8c7';
const css = `._image_3swl5_1 {
  display: inline-block;
  position: relative;
  max-width: 100%;
  text-align: center;
}

._imageInline_3swl5_8 {
  display: inline-block;
  margin: 0.2em;
  max-width: 100%;
}

._imageBlock_3swl5_14 {
  display: block;
  text-align: center;
  margin: 0.2em;
}

._loader_3swl5_20 {
  container-type: size;
  position: absolute;
  inset: 0;
  background-color: rgba(
    var(--theme-rgb-primary-background, 255, 255, 255),
    0.25
  );
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

._loaderInline_3swl5_34 {
  pointer-events: none;
  display: inline-block;
  margin-right: 0.25rem;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"image":"_image_3swl5_1","imageInline":"_imageInline_3swl5_8","imageBlock":"_imageBlock_3swl5_14","loader":"_loader_3swl5_20","loaderInline":"_loaderInline_3swl5_34"};
export { css, digest };
  